<template>
    <div>
        <div v-if="loading" class="lds-dual-ring"></div>
        <div v-else class="box-offset">
            <div class="box-ttl-wrap">
                <div class="box-ttl">Notes</div>
                <div class="box-search">
                    <button
                        class="box-search-btn"
                        type="submit"
                        @click="getListOfAdminsNotes"
                    >
                        <img src="/img/svg/icons-search.svg" alt="search"></button>
                    <input
                        type="search"
                        class="box-search-txt"
                        v-model="filters.search"
                        @input="handleSearch"
                    />
                </div>
            </div>
            <div class="table-holder table-responsive notifications-table">
                <table class="table">
                    <thead>
                    <tr>
                        <th style="padding-left: 0.75rem">Applicants</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                        v-for="comment in listOfAdminsComments"
                        :key="comment.id"
                    >
                        <td @click="redirectToApplicantsNotes(comment.applicant.id)">
                            <div class="item-inner">
                                <div class="item-ttl">
                                    <h5>{{comment.applicant.name ?? ''}} {{comment.applicant.last_name ?? ''}}</h5>
                                    <div class="date-time">{{formatDate(comment.created_at)}}</div>
                                </div>
                                <p>
                                    <pre style="white-space: pre-wrap; font-family: 'Open Sans', sans-serif; font-size: 14px;">{{ comment.comment }}</pre>
                                </p>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <Pagination
                :currentPage="pagination.current_page"
                :lastPage="pagination.last_page"
                @changePage="changePage"
                @changeItemsPerPage="changeItemsPerPage"
            />
        </div>
    </div>

</template>

<script>
import Pagination from "../../../../../../resources/js/components/Pagination.vue";
import PaginationHandler from "../../../../../../resources/js/mixins/PaginationHandler";
import UsersServices from "../services/UsersServices";
import DateConverter from "../../../../../../resources/js/mixins/DateConverter";
import {createDebouncedFunction} from "../../../../../../resources/js/plugins/debounce";

export default {
    name: 'NotesByAdmin',
    components: {Pagination},
    mixins: [PaginationHandler, DateConverter],
    props: {
        id: {
            type: Number
        }
    },
    data() {
        return {
            listOfAdminsComments: [],
            loading: true,
            filters: {
                search: ''
            },
            pagination: {
                current_page: 1,
                last_page: 1,
            },
        }
    },
    methods: {
        redirectToApplicantsNotes(applicantId) {
            window.location = `/master-admin/applicants/${applicantId}/show?tab=Notes`
        },
        getList(filters) {
            this.getListOfAdminsNotes(filters)
        },
        async getListOfAdminsNotes() {
            try {
                const {data: response} = await UsersServices.getListOfAdminComments(this.id, this.filters)
                this.listOfAdminsComments = response.data
                this.pagination.current_page = response.current_page
                this.pagination.last_page = response.last_page
                this.loading = false
            } catch(e) {
                console.error(e)
            }
        },
        handleSearch() {
            this.filters.page = 1
            this.delayedSearch();
        },
    },
    mounted() {
        this.getListOfAdminsNotes()
        this.delayedSearch = createDebouncedFunction(() => this.getListOfAdminsNotes(), 500);
    }
}

</script>



<style scoped>

</style>
